// Sidebar.vue
<template>
  <div>
    <transition name="fade">
      <Overlay @on-click="$emit('closeSidebarPanel')" v-if="isPanelOpen" />
    </transition>
    <transition
      :name="position === 'bottom' ? 'slide-up-half' : ''"
    >
      <div
        v-if="isPanelOpen"
        class="overflow-y-auto bg-greyBackground fixed right-0 z-20 px-4 grid items-start content-start rounded-t-2xl w-screen"
        :style="{
          height: panelHeight ? panelHeight : (position === 'bottom' ? '50%' : '100%')
        }"
        :class="{
          'bottom-0': position === 'bottom',
          'py-4' : paddingTopBottom === 'paddingTopBottomShow',
          'py-0' : paddingTopBottom === 'paddingTopBottomHide',
        }"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import Overlay from './Overlay.vue';

export default {
  name: 'Sidebar',
  components: {
    Overlay,
  },
  props: {
    isPanelOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    position: {
      type: String,
      required: false,
      default: 'bottom',
    },
    paddingTopBottom: {
      type: String,
      required: false,
      default: 'paddingTopBottomShow',
    },
    panelHeight: {
      type: String, // Change this to Number if you're passing a number
      required: false,
      default: '',
    },
  },
};
</script>

<style lang='scss' scoped>
.slide-up-half-enter-active,
.slide-up-half-leave-active {
  transition: transform 0.2s ease;
}

.slide-up-half-enter-from,
.slide-up-half-leave-to {
  transform: translateY(100%);
  transition: all 150ms ease-in 0s;
}
</style>
